import React, { useEffect, useState } from "react";
import { server } from "../../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../../store/stateFunctions";
import Swal from "sweetalert2";
import { AiFillDelete } from "react-icons/ai";
import withReactContent from "sweetalert2-react-content";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import configContext from "../../../context/configContext/configContext";

const swalalert = withReactContent(Swal);

const StudentEnquiries = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [yuvadata, setYuvaData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getMerchantEnquiry();
    getYuvasarathiInquiry();
  }, []);

  // Get
  const getMerchantEnquiry = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/shopdetails/getenquirycount", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getYuvasarathiInquiry = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/adminmerchant/getstdinquiries", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setYuvaData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete

  const deleteMerchantEnquiry = (data) => {
    console.log("data:", data);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.shop_name} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/shopdetails/deleteenquiry/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getMerchantEnquiry();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // Delete
  const deleteAdminMerchantEnquiry = (yuvadata) => {
    console.log("data:", yuvadata);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${yuvadata.shop_name} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/adminmerchant/deletestdenquiry/${yuvadata.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getYuvasarathiInquiry();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  return (
    <div>
      <h3 className="text-center my-2 text-uppercase">My Enquiries</h3>
      <div className=" row ">
        {/* <div className="col-md-4 text-end my-1">
          <select className="form-control text-uppercase" name="" id="">
            <option value="">Gyms</option>
            <option value="">Cafe's</option>
            <option value="">Lodge</option>
            <option value="">Bakery</option>
            <option value="">Classes</option>
            <option value="">Library</option>
            <option value="">Travels</option>
            <option value="">Laundry</option>
            <option value="">Garriage</option>
            <option value="">Medicals</option>
            <option value="">Restaurants</option>
            <option value="">Stationery</option>
            <option value="">Cyber Cafe</option>
            <option value="">Event Decors</option>
            <option value="">PG/Hostels</option>
            <option value="">Doctors/Clinic</option>
            <option value="">Salons/Parlours</option>
            <option value="">Mess/Parcel Points</option>
          </select>
        </div>
        <div className="col-md-4 text-start my-1"></div>
        <div className="col-md-4 text-start my-1">
          <input
            type="search"
            name=""
            id=""
            className="form-control"
            placeholder="Search"
          />
        </div> */}
      </div>

      <div className="container ">
        <div className="row  shadow-sm text-center mb-3">
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/myeventenquiries">
                Event Enquiries
              </NavLink>
            </h5>
          </div>
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/myenquiries">
                Merchant Enquiries
              </NavLink>
            </h5>
          </div>
        </div>
      </div>

      <table className="table table-striped border">
        <thead>
          <tr>
            <th scope="col">Sr. No.</th>
            <th scope="col">Shop Name</th>
            <th scope="col">Category</th>
            <th scope="col">Address</th>
            <th scope="col">Delete</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data?.map((item, index) => {
              return (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.shop_name}</td>
                  <td>{item.category}</td>
                  <td>{item.address}</td>
                  <td>
                    <div className="btn banner text-white">
                      <AiFillDelete
                        onClick={() => deleteMerchantEnquiry(item)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          {yuvadata &&
            yuvadata?.map((item, index) => {
              return (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.shop_name}</td>
                  <td>{item.shop_category}</td>
                  <td>{item.shop_address}</td>
                  <td>
                    <div className="btn banner text-white">
                      <AiFillDelete
                        onClick={() => deleteAdminMerchantEnquiry(item)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default StudentEnquiries;
